import { doc, getFirestore, setDoc } from "firebase/firestore";
import { DateTime } from "luxon";
import { PassportRequest, PassportRequestStatus } from "../types/PassportRequest";

export const updatePassportRequest = async (passportRequest: PassportRequest, status: PassportRequestStatus) => {
  const db = getFirestore();

  let data: any = {
    status, 
    dateResponded: DateTime.utc().toISO(),
  };

  if (status === 'Returned') {
    data = {
      ...data,
      dateReturned: DateTime.utc().toISO(),
    };
  }

  await setDoc(
    doc(db, `Employees/${passportRequest.idNumber}/PassportRequests/${passportRequest.id}`),
    data,
    { merge: true }
  );
};